import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
	currentYear;
	ngOnInit() {
		this.currentYear = /\d{4}/.exec(Date())[0];
	}

	scrollToTop() {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}
}
